import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  state: {
    isAuthenticated: false,
    user: {
      id: null,
      roles: [], // รายการ roles ของผู้ใช้
      token: '', // token ของผู้ใช้
      dept: {},
      username: '',
      showRegisterModal: false,
      profileImage: '',
    },
    statusId: null,
    currentLanguage: 'th',
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    userRoles: state => state.user.roles,
    authToken: state => state.user.token,
    userId: state => state.user.id,
    deptId: state => state.user.dept.id || '',
    username: state => state.user.username,
    profileImage: state => state.user.profileImage,
    currentLanguage: state => state.currentLanguage,
  },
  mutations: {
    SET_SHOW_REGISTER_MODAL(state, payload) {
      state.showRegisterModal = payload
    },
    setAuthenticated(state, status) {
      state.isAuthenticated = status
    },
    setUser(state, user) {
      state.isAuthenticated = !!user.token
      state.user = {
        id: user.id || null,
        roles: Array.isArray(user.roles) ? user.roles : [],
        token: user.token || '',
        dept: user.dept || {},
        username: user.username || '',
        profileImage: user.profileImage || '',
      }
    },
    clearUser(state) {
      state.isAuthenticated = false
      state.user = { roles: [], token: '', dept: '' }
    },
    setStatusId(state, id) {
      state.statusId = id // อัปเดต statusId
      console.log('statusId updated to:', state.statusId)
    },
    setLanguage(state, language) {
      state.currentLanguage = language
    },
  },
  actions: {
    openRegisterModal({ commit }) {
      commit('SET_SHOW_REGISTER_MODAL', true)
    },
    closeRegisterModal({ commit }) {
      commit('SET_SHOW_REGISTER_MODAL', false)
    },
    login({ commit }, user) {
      return new Promise(resolve => {
        commit('setAuthenticated', true)
        commit('setUser', {
          id: user.id,
          roles: Array.isArray(user.roles) ? user.roles : [],
          token: user.token || '',
          dept: user.dept || {},
          username: user.username || '',
          profileImage: user.profileImage || '',
        })
        localStorage.setItem('id', user.id || '')
        localStorage.setItem('accessToken', user.token || '')
        localStorage.setItem('dept', JSON.stringify(user.dept) || '{}')
        localStorage.setItem('roles', JSON.stringify(user.roles || []))
        localStorage.setItem('username', user.username || '')
        localStorage.setItem('profileImage', user.profileImage || '')
        resolve() // ให้ Promise เสร็จสมบูรณ์
      })
    },
    logout({ commit }) {
      commit('clearUser') // เคลียร์ข้อมูลผู้ใช้
      localStorage.clear() // ลบข้อมูลใน localStorage
    },
    initializeStore({ commit }) {
      const roles = JSON.parse(localStorage.getItem('roles')) || []
      const token = localStorage.getItem('accessToken') || ''
      const userId = localStorage.getItem('id') || null
      const dept = JSON.parse(localStorage.getItem('dept')) || {}
      const username = localStorage.getItem('username') || ''
      const profileImage = localStorage.getItem('profileImage') || ''
      commit('setUser', {
        id: userId, roles, token, dept, username, profileImage,
      })
      commit('setAuthenticated', !!token) // ตรวจสอบ token ว่ามีหรือไม่
    },
    changeLanguage({ commit }, language) {
      commit('setLanguage', language)
    },
  },
  strict: process.env.NODE_ENV !== 'production',
})
